import React from 'react';

export const MATCH_TAB = {
    MATCH: 'match',
    STATS: 'stats',
    LINEUPS: 'lineups',
    SUMMARY: 'summary'
};

const TAB_ITEMS = [
    { id: MATCH_TAB.MATCH, label: 'Match' },
    { id: MATCH_TAB.STATS, label: 'Stats' },
    { id: MATCH_TAB.LINEUPS, label: 'Lineups' },
    { id: MATCH_TAB.SUMMARY, label: 'Summary' }
];

const LockIcon = () => (
    <svg
        className="mx-tabs__lock"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        aria-hidden="true"
    >
        <rect x="5" y="11" width="14" height="9" rx="2" />
        <path d="M8 11V7a4 4 0 018 0v4" />
    </svg>
);

/**
 * In-page segmented control. Replaces the routed nav on the match page only:
 * the /lineups and /summary routes stay live for deep links.
 * Summary shows a padlock until the match is completed.
 */
function MatchTabs({ activeTab, onSelectTab, isSummaryUnlocked = false }) {
    return (
        <nav className="mx-tabs" role="tablist" aria-label="Match sections">
            {TAB_ITEMS.map((tab) => {
                const isSummary = tab.id === MATCH_TAB.SUMMARY;
                const isLocked = isSummary && !isSummaryUnlocked;

                return (
                    <button
                        key={tab.id}
                        type="button"
                        role="tab"
                        aria-selected={activeTab === tab.id}
                        className={activeTab === tab.id ? 'is-active' : undefined}
                        data-testid={`match-tab-${tab.id}`}
                        onClick={() => onSelectTab(tab.id)}
                    >
                        {tab.label}
                        {isLocked && <LockIcon />}
                    </button>
                );
            })}
        </nav>
    );
}

export default MatchTabs;
